/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createStore, createApi, createEffect, sample } from 'effector';

export type TModal$State<T> = {
  login: boolean;
  changePassword: boolean;
  removePosition: boolean;
  portfolio: boolean;
  removePortfolio: boolean;
  changePosition: boolean;
  removeDelayedSignal: boolean;
  accountRebalance: boolean;
  accCalcRebalance: boolean;
  accountBlock: boolean;
  serviceStop: boolean;
  faqAddCategory: boolean;
  faqDeleteCategory: boolean;
  faqAddQuestion: boolean;
  faqDeleteQuestion: boolean;
  comment: boolean;
  data?: T;
};

const initialState: TModal$State<any> = {
  login: false,
  changePassword: false,
  removePosition: false,
  portfolio: false,
  removePortfolio: false,
  changePosition: false,
  removeDelayedSignal: false,
  accountRebalance: false,
  accCalcRebalance: false,
  accountBlock: false,
  serviceStop: false,
  faqAddCategory: false,
  faqDeleteCategory: false,
  faqAddQuestion: false,
  faqDeleteQuestion: false,
  comment: false,
};

export const Modals$ = createStore<TModal$State<any>>(initialState);

const { show, hide } = createApi(Modals$, {
  // @ts-ignore
  show: (state, { modalId, data }) => {
    const newState = { ...initialState };
    // @ts-ignore
    newState[modalId] = true;
    newState.data = data;

    return newState;
  },
  hide: () => initialState,
});

export const modalApi = {
  show: createEffect(),
  hide: createEffect(),
};

sample({
  clock: modalApi.show,
  target: show,
});

sample({
  clock: modalApi.hide,
  target: hide,
});
